import * as NaturalDivTwoDigitTensOnesTask from "./podtemat3_dzielenie_types/NaturalDivTwoDigitTensOnesTask";
import * as NaturalDivTableTask from "./podtemat3_dzielenie_types/NaturalDivTableTask";
import * as NaturalDivConvenientSplitTask from "./podtemat3_dzielenie_types/NaturalDivConvenientSplitTask";
import * as NaturalDivLargerSplitTask from "./podtemat3_dzielenie_types/NaturalDivLargerSplitTask";
import * as NaturalDivRemainderTableTask from "./podtemat3_dzielenie_types/NaturalDivRemainderTableTask";
import * as NaturalDivRemainderTwoDigitTask from "./podtemat3_dzielenie_types/NaturalDivRemainderTwoDigitTask";
import * as NaturalDivRemainderLargerTask from "./podtemat3_dzielenie_types/NaturalDivRemainderLargerTask";
import * as NaturalDivWithZerosTask from "./podtemat3_dzielenie_types/NaturalDivWithZerosTask";

export const registry = {
  NaturalDivTwoDigitTensOnesTask,
  NaturalDivTableTask,
  NaturalDivConvenientSplitTask,
  NaturalDivLargerSplitTask,
  NaturalDivRemainderTableTask,
  NaturalDivRemainderTwoDigitTask,
  NaturalDivRemainderLargerTask,
  NaturalDivWithZerosTask,
};

export function generateTasks() {
  return [
    NaturalDivTwoDigitTensOnesTask.generateTask(),
    NaturalDivTableTask.generateTask(),
    NaturalDivConvenientSplitTask.generateTask(),
    NaturalDivLargerSplitTask.generateTask(),
    NaturalDivWithZerosTask.generateTask(),
    NaturalDivRemainderTableTask.generateTask(),
    NaturalDivRemainderTwoDigitTask.generateTask(),
    NaturalDivRemainderLargerTask.generateTask(),
  ];
}

export function renderTask(task) {
  const m = registry[task.type];
  return m ? m.renderTask(task) : null;
}

export function renderInput(task, userAnswer, onChange, disabled) {
  const m = registry[task.type];
  return m ? m.renderInput(task, userAnswer, onChange, disabled) : null;
}

export function checkAnswer(task, userAnswer) {
  const m = registry[task.type];
  return m ? m.checkAnswer(task, userAnswer) : false;
}

export function renderAnswer(task) {
  const m = registry[task.type];
  return m ? m.renderAnswer(task) : null;
}

export function renderExplanation(task) {
  const m = registry[task.type];
  return m ? m.renderExplanation(task) : null;
}

export function renderUserAnswer(task, userAnswer) {
  const m = registry[task.type];
  return m && m.renderUserAnswer ? m.renderUserAnswer(userAnswer) : null;
}

const naturalDivisionSubtopic = {
  registry,
  generateTasks,
  renderTask,
  renderInput,
  checkAnswer,
  renderAnswer,
  renderExplanation,
  renderUserAnswer,
};

export default naturalDivisionSubtopic;
